import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core'
import { OptionsNgxOwCarouselService } from 'dmmp-services'
import { CarouselComponent } from 'ngx-owl-carousel-o'

@Component({
  selector: 'dmmp-banner-content-mobile',
  templateUrl: './banner-content-mobile.component.html'
})
export class BannerContentMobileComponent implements OnInit {

  @Input() module: any
  @Input() configCarousel

  @Output() anchorCustom = new EventEmitter()
  @Output() page = new EventEmitter()

  totalSlides = 0
  currentSlide = 0
  @ViewChild('slide') carrousel: CarouselComponent

  externContent : any[] = []

  constructor(private options: OptionsNgxOwCarouselService) { }

  ngOnInit(): void {
    this.configCarousel = this.options.configurationBenefits(this.module)
    this.totalSlides = this.module?.content?.length
    this.module?.content?.forEach(contentItem => {
      this.totalSlides += contentItem.related_content.length
      contentItem?.row ?  contentItem?.row.forEach(item => {
        item.columns ? item.columns.forEach(column => {
          if(column?.in_related_content === true){
            this.totalSlides += 1
            this.externContent = [...this.externContent, column]
          }
        }) : false
      }) : false
    })

  }

  changeCarousel(event) {
    this.currentSlide = event?.startPosition
  }

}
